<template>
  <div v-if="isEdit == null">
    <div id="chi-tiet-don-vi">
      <div>
        <b-form class="chi-tiet-log-he-thong">
          <b-row v-if="data">
            <b-col sm="6" lg="6" class="d-flex mb-3">
              <span class="pb-2 mr-3 font-weight-bold d-inline-block label"
                >Tên cấp đơn vị:</span
              >
              <span>{{ data.tenCapDonVi }}</span>
            </b-col>
            <b-col sm="6" lg="6" class="d-flex mb-3">
              <span class="pb-2 mr-3 font-weight-bold d-inline-block label"
                >Mã cấp đơn vị:</span
              >
              <span>{{ data.maCapDonVi }}</span>
            </b-col>
            <b-col sm="6" lg="6" class="d-flex mb-3">
              <span class="pb-2 mr-3 font-weight-bold d-inline-block label"
                >Thứ tự:</span
              >
              <span>{{ data.thuTu }}</span>
            </b-col>
            <b-col sm="6" lg="6" class="d-flex mb-3">
              <span class="pb-2 mr-3 font-weight-bold d-inline-block label"
                >Cấp đơn vị cha:</span
              >
              <span>{{ data.tenCapDonViCha }}</span>
            </b-col>
          </b-row>
          <div class="text-center" v-else>Không có dữ liệu.</div>
        </b-form>
      </div>
    </div>
  </div>
  <div v-else>
    <div class="d-flex justify-content-end mb-2 h-20px">
      <div class="btn-tab-position-area">
        <base-button class="btn btn-green" @click="onSubmit" button="Lưu" />
        <base-button
          class="btn btn-yellow ml-2"
          @click="refreshData"
          button="Làm mới"
        />
        <base-button
          class="btn btn-yellow ml-2"
          @click="hideModal"
          button="Đóng"
        />
      </div>
    </div>
    <validation-observer ref="observerCapDonVi" class="row">
      <b-form class="col col-6">
        <validation-provider
          rules="required|maxlength:50"
          name="Cấp đơn vị"
          v-slot="validationContext"
        >
          <b-form-group
            class="mb-2 required"
            id="tenCapDonVi-input-group"
            label="Tên cấp đơn vị"
            label-for="tenCapDonVi-input"
            label-class="font-weight-bold"
          >
            <b-form-input
              :state="getValidationState(validationContext)"
              aria-describedby="tenCapDonVi-live-feedback"
              class="border-radius-4"
              id="tenCapDonVi-input"
              name="tenCapDonVi-input"
              v-model="form.tenCapDonVi"
            ></b-form-input>
            <b-form-invalid-feedback id="tenCapDonVi-live-feedback"
              >{{ validationContext.errors[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>
      </b-form>
      <b-form class="col col-6">
        <validation-provider
          rules="required|maxlength:50|code|hashcode"
          name="Mã cấp đơn vị"
          v-slot="validationContext"
        >
          <b-form-group
            class="mb-2 required"
            id="tenCapDonVi-input-group"
            label="Mã cấp đơn vị"
            label-for="tenCapDonVi-input"
            label-class="font-weight-bold"
          >
            <b-form-input
              :state="getValidationState(validationContext)"
              aria-describedby="tenCapDonVi-live-feedback"
              class="border-radius-4"
              id="tenCapDonVi-input"
              name="tenCapDonVi-input"
              v-model="form.maCapDonVi"
            ></b-form-input>
            <b-form-invalid-feedback id="tenCapDonVi-live-feedback"
              >{{ validationContext.errors[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>
      </b-form>
      <b-form-group
        class="mb-2 col col-6"
        id="thuTu-input-group"
        label="Thứ tự"
        label-class="font-weight-bold"
        label-for="thuTu-input"
      >
        <b-form-input
          aria-describedby="thuTu-live-feedback"
          class="border-radius-4"
          id="thuTu-input"
          name="thuTu-input"
          type="number"
          v-model="form.thuTu"
        ></b-form-input>
      </b-form-group>
      <b-form-group
        class="col col-6"
        label="Cấp đơn vị cha"
        label-class="font-weight-bold"
        label-for="donVi"
      >
        <treeselect
          noOptionsText="Không có dữ liệu"
          noResultsText="Không có kết quả"
          noChildrenText="Không có kết quả"
          v-model="form.parentId"
          :options="danhSachCapDonViNoiBo || []"
          placeholder="Chọn đơn vị"
          @input="isErrorDonViCha"
        >
          <label
            :class="labelClassName"
            slot="option-label"
            slot-scope="{
              node,
              shouldShowCount,
              count,
              labelClassName,
              countClassName,
            }"
          >
            {{ node.label }}
            <span :class="countClassName" v-if="shouldShowCount && count > 0"
              >({{ count }})</span
            >
          </label>
        </treeselect>
      </b-form-group>
    </validation-observer>
  </div>
</template>

<script>
import { BO_QUA_BUTTON_LABEL, ROUTE_NAME } from "@/constants/constants";
import { showMsgError } from "@/utils/commonUtils";
import { Treeselect } from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
// import { isEmpty } from "lodash";

export default {
  name: "FormCapNhatCapDonVi",
  components: { Treeselect },
  props: {
    data: {
      type: Object,
    },
    isEdit: {
      type: Boolean,
      Nullable: true,
      default: null,
    },
    isXemChiTiet: { type: Boolean, default: true },
    danhSachCapDonVi: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      ROUTE_NAME: ROUTE_NAME,
      BO_QUA_BUTTON_LABEL: BO_QUA_BUTTON_LABEL,
      form: {
        tenCapDonVi: "",
        maCapDonVi: "",
        thuTu: null,
        parentId: null,
      },
      isLoading: false,
    };
  },
  computed: {
    danhSachCapDonViNoiBo() {
      return (this.danhSachCapDonVi || []).map((x) => {
        return { ...x, label: x.tenCapDonVi };
      });
    },
  },
  methods: {
    selectClass(valid) {
      return {
        "is-invalid select-invalid treeselect-invalid": valid,
      };
    },
    getValidationState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    hideModal() {
      this.$emit("hidden");
    },
    layThuTuMacDinh() {
      if (this.form?.parentId) {
        this.$store
          .dispatch("capDonVi/layThuTuMacDinh", {
            idCha: this.form.parentId,
          })
          .then((res) => {
            if (res.data.succeeded) {
              this.form.thuTu = res.data.data;
            } else {
              console.log("Thao tác thất bại");
            }
          });
      }
    },
    resetForm() {
      this.form = {
        tenCapDonVi: "",
        maCapDonVi: "",
        thuTu: null,
        parentId: null,
      };
    },
    refreshData() {
      if (this.isEdit !== null) {
        if (this.isEdit === true) {
          this.form = Object.assign(this.form, this.data);
        } else {
          let parentId = this.data?.id;
          this.resetForm();
          this.form.parentId = parentId;
          this.layThuTuMacDinh();
        }
      } else {
        this.resetForm();
      }
    },
    isErrorDonViCha() {
      if (
        this.form.iD_DonVi_Cha &&
        this.form.id &&
        this.form.iD_DonVi_Cha === this.form.id
      ) {
        this.$toasted.clear();
        this.$toasted.global.showErrorMessage({
          message: "Đơn vị cha không thể là đơn vị hiện tại",
        });
        return true;
      }
      return false;
    },
    async onSubmit() {
      const isValid = await this.$refs.observerCapDonVi.validate();
      const $vm = this;
      let thuTu = parseInt(this.form.thuTu);
      thuTu = isNaN(thuTu) ? null : thuTu;
      const payload = {
        ...this.form,
        thuTu: thuTu,
      };
      if (isValid) {
        this.isLoading = true;
        if (this.isEdit) {
          this.$store
            .dispatch("capDonVi/suaCapDonVi", {
              data: payload,
              onSuccess: $vm.hideModal,
            })
            .then(() => {
              $vm.hideModal();
              $vm.$emit("refreshData", payload);
              this.isLoading = false;
            })
            .catch((err) => {
              this.isLoading = false;
              if (err) showMsgError(err.data.message);
            });
        } else {
          this.$store
            .dispatch("capDonVi/themCapDonVi", {
              data: payload,
              onSuccess: $vm.hideModal,
            })
            .then(() => {
              $vm.hideModal();
              $vm.$emit("refreshData");
              this.isLoading = false;
            })
            .catch((err) => {
              if (err) showMsgError(err.data.message);
              this.isLoading = false;
            });
        }
      }
    },
  },
  watch: {
    data: function () {
      this.refreshData();
    },
    isEdit: function () {
      this.refreshData();
    },
  },
};
</script>
<style>
.h-20px {
  height: 20px;
}
</style>
